module.exports = __webpack_public_path__ + "static/fonts/Montserrat-SemiBold.1fe3da7.woff2";